<rid-mechanic-background />

@let _state = state();

<rid-mechanic-wrapper>
  <rid-top-bar
    class="block w-full"
    name="Leeslijst | Stopwatch"
    [steps]="matrices().length"
    [progress]="_state.type === 'INSTRUCTION' ? 0 : _state.type === 'READING' ? index() : matrices().length"
  />

  <rid-mechanic-content>
    @if (_state.type !== 'INSTRUCTION') {
      <!-- title -->
      @if (_state.type === 'READING') {
        <rid-mechanic-title animate.enter="wait-500" [title]="'Lees de woorden nauwkeurig en snel hardop'" />
      }

      <!-- matrices -->
      <rid-horizontal-pages [pageCount]="matrices().length" (navigated)="index.set($event)">
        @for (matrix of matrices(); track $index) {
          <rid-word-matrix [matrix]="matrix" />
        }
      </rid-horizontal-pages>

      <!-- buttons -->
      @if (_state.type === 'READING' && index() === matrices().length - 1) {
        <rid-bottom-button content="Klaar!" (clicked)="finishReading()" />
      }
      @if (_state.type === 'VIEWING') {
        <div class="absolute bottom-8 flex justify-center gap-4">
          <rid-button
            class="w-xs"
            animate.enter="anim-slide-from-bottom"
            animate.leave="anim-slide-to-bottom"
            content="Nog een keer"
            variant="SECONDARY"
            [disabled]="true"
          />
          <rid-button
            class="w-xs"
            animate.enter="anim-slide-from-bottom"
            animate.leave="anim-slide-to-bottom"
            content="Volgende"
            (click)="finish()"
          />
        </div>
      }

      <!-- review toast -->
      @if (_state.type === 'FEEDBACK') {
        @let prev = previousDuration();
        <rid-feedback-toast
          [title]="_state.duration + (_state.duration | plural: ' seconde' : ' seconden') + '!'"
          [description]="
            prev
              ? _state.duration === prev
                ? 'Dat is even snel als vorige keer!'
                : _state.duration > prev
                  ? 'Dat is ' +
                    (_state.duration - prev) +
                    (_state.duration - prev | plural: ' seconde' : ' seconden') +
                    ' meer dan vorige keer.'
                  : 'Dat is ' +
                    (prev - _state.duration) +
                    (prev - _state.duration | plural: ' seconde' : ' seconden') +
                    ' minder dan vorige keer!'
              : ''
          "
          [variant]="prev === undefined || _state.duration >= prev ? 'INFO' : 'SUCCESS'"
          (click)="state.set({ type: 'RATING' })"
          (continued)="state.set({ type: 'RATING' })"
        />
      }

      <!-- overlay -->
      @if (_state.type === 'RATING') {
        <rid-modal-background />
        <rid-rating-modal (canceled)="state.set({ type: 'VIEWING' })" (continued)="finish()" />
      }
    }

    @if (_state.type === 'INSTRUCTION') {
      <rid-modal-background [blur]="true" />
      <rid-instruction-modal (started)="start()">
        Lees alle woorden hardop.<br />Doe dit zo nauwkeurig en snel mogelijk. Druk dan op 'Klaar!'.
      </rid-instruction-modal>
    }
  </rid-mechanic-content>
</rid-mechanic-wrapper>
